import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function logEntryReducer(state = initialState.logEntries, action) {
    let newState = state;

    switch (action.type) {
        case types.CREATE_LOGENTRY:
            if (action.status === 'success'){
                newState = createLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CREATE_COMMAND_LOGENTRY:
            if (action.status === 'success'){
                newState = createCommandLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_LOGENTRY:
            if (action.status === 'success'){
                newState = deleteLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_BY_TASK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    userTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_BY_TIMESHEET:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    logEntriesByTimesheet: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_BY_TIMESHEET_TASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    logEntriesByTimesheetTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_ON_DATE:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    logEntriesOnDate: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_ON_DATE_FOR_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    logEntriesOnDateForUser: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_ON_WEEK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    logEntriesOnWeek: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_LOGENTRIES_ON_WEEK_FOR_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    logEntriesOnWeekForUser: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_CREATE_LOGENTRY:
            if (action.status === 'success'){
                newState = pmoCreateLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_DELETE_LOGENTRY:
            if (action.status === 'success'){
                newState = pmoDeleteLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_EDIT_LOGENTRY_STATUS:
            if (action.status === 'success'){
                newState = pmoEditLogEntryStatus(state, action.data.logEntryID, action.data.status);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_UPDATE_LOGENTRY:
            if (action.status === 'success'){
                newState = pmoUpdateLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_UPDATE_LOGENTRY_TASK:
            if (action.status === 'success'){
                newState = pmoUpdateLogEntryTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_LOGENTRY_STATE:
            return Object.assign({}, state, {
                loading: true
            });
        case types.STOP_TIMER_LOGENTRY:
            if (action.status === 'success'){
                newState = stopTimerLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.UPDATE_LOGENTRY:
            if (action.status === 'success'){
                newState = updateLogEntry(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.UPDATE_LOGENTRY_TASK:
            if (action.status === 'success'){
                newState = updateLogEntryTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        default:
            return state;
    }
}

function createLogEntry (state, logEntry) {

    return Object.assign({}, state, {
        loading: false,
        logEntriesOnDate: [...state.logEntriesOnDate, logEntry],
        logEntriesOnWeek: [...state.logEntriesOnWeek, logEntry]
    });
}

function createCommandLogEntry (state, command) {
    // TODO later
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function deleteLogEntry (state, logEntryID) {  
    let logEntryListWeek = state.logEntriesOnWeek;
    let logEntryListDate = state.logEntriesOnDate;
    
    let index = list.findIndexByID(logEntryListWeek, logEntryID);
    logEntryListWeek = list.remove(logEntryListWeek, index);
    
    index = list.findIndexByID(logEntryListDate, logEntryID);
    logEntryListDate = list.remove(logEntryListDate, index);
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeek: logEntryListWeek,
        logEntriesOnDate: logEntryListDate
    });
}

function pmoCreateLogEntry (state, logEntry) {
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeekForUser: [...state.logEntriesOnWeekForUser, logEntry]
    });
}

function pmoDeleteLogEntry (state, logEntryID) {
    let logEntryListWeekForUser = state.logEntriesOnWeekForUser;
    
    let index = list.findIndexByID(logEntryListWeekForUser, logEntryID);
    logEntryListWeekForUser = list.remove(logEntryListWeekForUser, index);
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeekForUser: logEntryListWeekForUser,
    });
}

function pmoEditLogEntryStatus (state, logEntryID, status) {
    let logEntryListWeekForUser = state.logEntriesOnWeekForUser;

    let index = list.findIndexByID(logEntryListWeekForUser, logEntryID);
    logEntryListWeekForUser[index].status = status;

    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeekForUser: logEntryListWeekForUser,
    });
}

function pmoUpdateLogEntry (state, logEntry) {
    let logEntryListWeekForUser = state.logEntriesOnWeekForUser;
    
    let index = list.findIndexByID(logEntryListWeekForUser, logEntry.id);
    logEntryListWeekForUser = list.remove(logEntryListWeekForUser, index);
    logEntryListWeekForUser.push(logEntry);
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeekForUser: logEntryListWeekForUser,
    });
}

function pmoUpdateLogEntryTask (state, logEntry) {
    let logEntryListWeekForUser = state.logEntriesOnWeekForUser;
    
    let index = list.findIndexByID(logEntryListWeekForUser, logEntry.oldId);
    logEntryListWeekForUser = list.remove(logEntryListWeekForUser, index);
    logEntryListWeekForUser.push(logEntry);
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeekForUser: logEntryListWeekForUser,
    });
}

function stopTimerLogEntry (state, logEntry) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function updateLogEntry (state, logEntry) {
    let logEntryListWeek = state.logEntriesOnWeek;
    let logEntryListDate = state.logEntriesOnDate;
    
    let index = list.findIndexByID(logEntryListWeek, logEntry.id);
    logEntryListWeek = list.remove(logEntryListWeek, index);
    logEntryListWeek.push(logEntry);
    
    index = list.findIndexByID(logEntryListDate, logEntry.id);
    logEntryListDate = list.remove(logEntryListDate, index);
    logEntryListDate.push(logEntry);
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeek: logEntryListWeek,
        logEntriesOnDate: logEntryListDate
    });
}

function updateLogEntryTask (state, logEntry) {
    let logEntryListWeek = state.logEntriesOnWeek;
    let logEntryListDate = state.logEntriesOnDate;
    logEntry.taskID = logEntry.task.id;
    
    let index = list.findIndexByID(logEntryListWeek, logEntry.oldId);
    logEntryListWeek = list.remove(logEntryListWeek, index);
    logEntryListWeek.push(logEntry);
    
    index = list.findIndexByID(logEntryListDate, logEntry.oldId);
    logEntryListDate = list.remove(logEntryListDate, index);
    logEntryListDate.push(logEntry);
    
    return Object.assign({}, state, {
        loading: false,
        logEntriesOnWeek: logEntryListWeek,
        logEntriesOnDate: logEntryListDate
    });
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/logEntryReducer.js
 **/